import { c as _c } from "react/compiler-runtime";
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from './ConsultationModal.module.scss';
const SANITIZE_PATTERN: Record<'text' | 'tel', RegExp> = {
  text: /[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z\s]/g,
  tel: /\D/g
};
interface CounselingTextInputProps {
  readonly id: string;
  readonly label: string;
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly placeholder: string;
  readonly type: 'text' | 'tel';
}
export default function CounselingTextInput(t0) {
  const $ = _c(19);
  const {
    id,
    label,
    value,
    onChange,
    placeholder,
    type
  } = t0;
  let t1;
  if ($[0] !== onChange || $[1] !== type) {
    t1 = raw => {
      if (type === "tel" && raw.length > 11) {
        return;
      }
      if (type === "text" && raw.length > 100) {
        return;
      }
      onChange(raw.replace(SANITIZE_PATTERN[type], ""));
    };
    $[0] = onChange;
    $[1] = type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleChange = t1;
  let t2;
  if ($[3] !== label) {
    t2 = <Text as="p" className={styles.inputLabel} category="caption" variant="sb1" color="var(--color-gray-700)">{label}</Text>;
    $[3] = label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== id || $[6] !== t2) {
    t3 = <label htmlFor={id}>{t2}</label>;
    $[5] = id;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== handleChange) {
    t4 = e => handleChange(e.target.value);
    $[8] = handleChange;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== id || $[11] !== placeholder || $[12] !== t4 || $[13] !== type || $[14] !== value) {
    t5 = <input autoComplete="off" className={styles.textInput} value={value} onChange={t4} type={type} id={id} placeholder={placeholder} />;
    $[10] = id;
    $[11] = placeholder;
    $[12] = t4;
    $[13] = type;
    $[14] = value;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t5) {
    t6 = <div className={styles.inputContainer}>{t3}{t5}</div>;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}